import { render, staticRenderFns } from "./Callback.vue?vue&type=template&id=d84bc0ec&scoped=true&"
import script from "./Callback.vue?vue&type=script&lang=ts&"
export * from "./Callback.vue?vue&type=script&lang=ts&"
import style0 from "./Callback.vue?vue&type=style&index=0&id=d84bc0ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84bc0ec",
  null
  
)

export default component.exports